import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=59dd18cf&scoped=true&"
import script from "./addAddress.vue?vue&type=script&lang=js&"
export * from "./addAddress.vue?vue&type=script&lang=js&"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=59dd18cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd18cf",
  null
  
)

export default component.exports